import { defineModel, serializable } from '../model'

class Organization {
    /**
     * ...
     */
    @serializable()
    name: string

    @serializable()
    id: number

}

export default defineModel(Organization)
